<template>
  <div v-if="object">
    <div class="row text-white" style="background: #00bbff">
      <div class="col-md-11" style="text-align: left">
        <i class="tim-icons icon-simple-remove" v-on:click="toView" style="margin-right: 10px"></i>
        <b>{{item.object.name}}</b>
      </div>
      <div class="col-md-1" style="text-align: right">
        <i v-if="!inSave" class="tim-icons icon-check-2" v-on:click="save" style="margin-right: 10px"></i>
      </div>
    </div>

    <div class="row">
      <div class="col-md-8">
        <base-input label="Наименование"
                    v-model="object.name"
                    :placeholder="'-'">
        </base-input>
      </div>
      <div class="col-md-4">
        <base-input label="Артикул"
                    v-model="object.code"
                    :placeholder="'-'">
        </base-input>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <items-option :label="'Категория'" :object="object.category" @update="setCategory" :type="'productCategory'">
        </items-option>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <base-input label="Максимальный вес пациента, кг"
                    v-model="object.maxLoad"
                    :placeholder="'-'" :number="true">
        </base-input>
      </div>
      <div class="col-md-4">
        <base-input label="Строительня высота, мм"
                    v-model="object.buildHeight"
                    :placeholder="'-'" :number="true">
        </base-input>
      </div>
      <div class="col-md-4">
        <base-input label="Строимость, руб"
                    v-model="object.price"
                    :placeholder="'-'" :number="true">
        </base-input>
      </div>
    </div>

  </div>
</template>
<script>

 import SimpleRow from "@/components/SimpleRow";
 import BaseInput from "@/components/Inputs/BaseInput";
 import BaseCheckbox from "@/components/BaseCheckbox";
 import {longAsStringDate} from "@/services/utils";
 import {authHeader} from "@/services/auth-header";
 import {getPeriods} from "@/services/periods-service";

 export default {
   components: {
     SimpleRow,
     BaseInput,
     BaseCheckbox
   },
   props:{
     item: {},
     index: null,
     type: null
   },
   data() {
     return {
       socket: null,
       object: null,
       inSave: false
     }
   },
   methods: {
     convertDate(time) {
       return time ? longAsStringDate(time) : "-";
     },
     fieldView(data) {
       return data ? data : '-';
     },
     toView() {
       this.$emit('toView');
     },
     async save() {
       this.inSave = true;
       try {
         let renewed = await this.$repo.save(this.object, this.type);
         if (renewed) {
           this.item.object = renewed;
           this.item.id = renewed.id;
           this.object = JSON.parse(JSON.stringify(renewed));
           this.inSave = false;
           this.toView();
         }
       } catch(error) {
         this.inSave = false;
       }
     },
     setCategory(category) {
       this.object.category = category;
     }
   },
   mounted() {
     this.object = JSON.parse((JSON.stringify(this.item.object)));
   }
 }
</script>
